@if (careproviderUnit() !== null) {
  @if (displayBookingBtn()) {
    <div [ngClass]="bottomSectionCssClass()"
         class="bottom-0 left-0 right-0 flex flex-col justify-stretch gap-4 p-4 w-full border-t border-grey-9 fixed lg:hidden z-3 bg-white"
    >
      @for (config of selectedCareService().bookingConfigurationData; track config.id) {
        @if (isInternal()) {
          <app-booking-btn
            [bookingConfigurationData]="config"
            [caregiverContactInfo]="careproviderUnit()?.caregiverContactInfo"
            [classList]="'booking-btn__narrow'"
            [gaEventAction]="
              eventActionEnum.VARDEN_BOOKING_CLICK_CARE_SERVICE_BOOKING_BTN
            "
            [gaEventCategory]="eventCategoryEnum.VARDEN_BOOKING"
            [gaEventLabel]="selectedCareService()?.id.toString()"
            [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
            [pageType]="dLPageTypeEnum.CARE_SERVICE_PAGE"
            size="lg"
          ></app-booking-btn>
        } @else {
          <app-booking-btn
            [bookingConfigurationData]="config"
            [caregiverContactInfo]="careproviderUnit()?.caregiverContactInfo"
            [classList]="'booking-btn__narrow'"
            [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
            [pageType]="dLPageTypeEnum.CARE_SERVICE_PAGE"
            size="lg"
          ></app-booking-btn>
        }
      }
    </div>
  }

  <div class="row full-width-bg" id="component-top">
    <div class="col">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs()"></app-breadcrumbs>
    </div>
  </div>

  <div
    (inViewportAction)="handleTabsInViewport($event)"
    [inViewportOptions]="{threshold: 0}"
    class="tabs-viewport-marker full-width-bg"
    inViewport
  >
    <div [ngStyle]="placeholderStyle()"></div>
    <div [ngClass]="topSectionCssClass()"
         class="top-section bg-white border-b-2 border-b-grey-9 flex justify-center items-start"
         id="top-section-container">
      <div class="max-w-[1184px] w-full">

        <app-care-service-info-top
          [careProviderContactInfo]="careproviderUnit()?.caregiverContactInfo"
          [careProviderUnitName]="careproviderUnit()?.name"
          [careProviderUnitUrl]="careProviderUnitUrl()"
          [careService]="selectedCareService()"
          [logoUrl]="logoUrl()"
          [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
        ></app-care-service-info-top>
        <app-care-service-short-description
          (moreClick)="handleMoreClick($event)"
          [description]="selectedCareService()?.shortDescription"
          [title]="selectedCareService()?.name"
        ></app-care-service-short-description>
        <div class="tabs-container min-h-12">
          <nav [tabPanel]="tabPanel" mat-align-tabs="start" mat-stretch-tabs="false" mat-tab-nav-bar>
            @for (link of tabs(); track link.label; let i = $index) {
              <a mat-tab-link
                 (click)="cpruTabsService.handleTabsIndexChange(link.name)"
                 [active]="highlightedSection() === link.name"> {{ link.label }} </a>
            }
          </nav>
          <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col">
      <div class="flex flex-col gap-12 md:gap-3">
        <section id="section-{{ routesAddonsEnums.CARESERVICE_BOKA }}">
          <app-care-service-book
            [bookingSettings]="careproviderUnit()?.bookingSettings"
            [careProviderContactInfo]="careproviderUnit()?.caregiverContactInfo"
            [careProviderUnitId]="careproviderUnit()?.id"
            [careProviderUnitName]="careproviderUnit()?.name"
            [careProviderUnitUrl]="careProviderUnitUrl()"
            [careService]="selectedCareService()"
            [logoUrl]="logoUrl()"
            [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
          ></app-care-service-book>
        </section>

        <section id="section-{{ routesAddonsEnums.CARESERVICE_DETAILS }}">
          <app-care-service-details
            [description]="selectedCareService()?.description"
            [discount]="selectedCareService()?.discount"
            [isFromPrice]="selectedCareService()?.isFromPrice"
            [name]="selectedCareService()?.name"
            [priceDescription]="selectedCareService()?.priceDescription"
            [price]="selectedCareService()?.price"
          ></app-care-service-details>
        </section>

        @if (!isMobile()) {
          <section id="section-{{ routesAddonsEnums.CARESERVICE_MORE }}">
            <app-care-service-list
              [bookingSettings]="careproviderUnit()?.bookingSettings"
              [careProviderContactInfo]="careproviderUnit()?.caregiverContactInfo"
              [careProviderUnitId]="careproviderUnit()?.id"
              [careProviderUnitName]="careproviderUnit()?.name"
              [careProviderUnitUrlPath]="careproviderUnit()?.urlPath"
              [careProviderUnitUrl]="careProviderUnitUrl()"
              [careServices]="careproviderUnit()?.careServices"
              [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
              [queryParams]="queryParams()"
              [selectedId]="careServiceId()"
            ></app-care-service-list>
          </section>
        }
      </div>
    </div>

    <div class="col-slg mt-3 lg:mt-0">
      <div class="flex flex-col gap-12 md:gap-3">
        <section id="section-{{ routesAddonsEnums.CARESERVICE_ABOUT }}">
          <app-care-service-about-cpru
            [city]="careproviderUnit()?.placeName"
            [description]="careproviderUnit()?.description"
            [image]="mainImage()"
            [name]="careproviderUnit()?.name"
            [url]="careProviderUnitUrl()"
          ></app-care-service-about-cpru>
        </section>

        @if (careproviderUnit()?.externalReviewSummary) {
          <section id="section-{{ routesAddonsEnums.CARESERVICE_IMPRESSION }}">
            <app-external-reviews
              [externalReviews]="careproviderUnit()?.externalReviewSummary"
            ></app-external-reviews>
          </section>
        }


        <section id="section-{{ routesAddonsEnums.CARESERVICE_REVIEWS }}">
          <app-ratings-list
            [cpruId]="careproviderUnit()?.id"
            [externalReviews]="careproviderUnit()?.externalReviewSummary"
            [name]="careproviderUnit()?.name"
            [reviewSettings]="careproviderUnit()?.reviewSettings"
            [reviewSummary]="careproviderUnit()?.reviewSummary"
            [reviews]="careproviderUnit()?.reviews"
          ></app-ratings-list>
        </section>

        @if (hasStaff()) {
          <section id="section-{{ routesAddonsEnums.CARESERVICE_STAFF }}">
            <app-cpru-staff-list
              [staffMembers]="careproviderUnit()?.staffMembers"
            ></app-cpru-staff-list>
          </section>
        }


        @if (hasContact()) {
          <section id="section-{{ routesAddonsEnums.CARESERVICE_CONTACT }}">
            <app-cpru-contact
              [bookingSettings]="careproviderUnit()?.bookingSettings"
              [id]="careproviderUnit()?.id"
              [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
              [phoneNumbers]="careproviderUnit()?.caregiverContactInfo?.phoneNumbers"
              [websiteUrl]="careproviderUnit()?.caregiverContactInfo?.websiteUrl"
            ></app-cpru-contact>
          </section>
        }

        @if (hasOpenHours()) {
          <section id="section-{{ routesAddonsEnums.CARESERVICE_OPENHOURS }}">
            <app-cpru-open-hours
              [serviceHours]="careproviderUnit()?.serviceHours"
            ></app-cpru-open-hours>
          </section>
        }


        <section id="section-{{ routesAddonsEnums.CARESERVICE_MAP }}">
          <app-cpru-map
            [address]="careproviderUnit()?.address"
            [caregiverUnitImages]="careproviderUnit()?.caregiverUnitImages"
            [id]="careproviderUnit()?.id"
            [name]="careproviderUnit()?.name"
            [urlPath]="careproviderUnit()?.urlPath"
          ></app-cpru-map>
        </section>

        @if (isMobile()) {
          <section id="section-{{ routesAddonsEnums.CARESERVICE_MORE }}">
            <app-care-service-list
              [bookingSettings]="careproviderUnit()?.bookingSettings"
              [careProviderContactInfo]="careproviderUnit()?.caregiverContactInfo"
              [careProviderUnitId]="careproviderUnit()?.id"
              [careProviderUnitName]="careproviderUnit()?.name"
              [careProviderUnitUrlPath]="careproviderUnit()?.urlPath"
              [careProviderUnitUrl]="careProviderUnitUrl()"
              [careServices]="careproviderUnit()?.careServices"
              [mainCaregiverUnitType]="careproviderUnit()?.mainCaregiverUnitType"
              [queryParams]="queryParams()"
              [selectedId]="careServiceId()"
            ></app-care-service-list>
          </section>
        }

      </div>

    </div>
  </div>
}
